import React from 'react';
import { Modal } from "react-bootstrap";
import ErrorMessage from './ErrorMessage';
import { diffCheck, formatAmount, formatDate, formatStatus } from "../../../../../../util/Helpers";
import { GiftCardIcon } from '../../../../../../util/Icons';


const UpdateGiftCard = ({ show, action: { action, error, data }, onHide }) => {
    const { meta: oldData, ...newData } = data

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <GiftCardIcon />
                    </span> {action}
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <ErrorMessage {...{ error }} />
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Vendor</h6>
                        <span className="text-muted">{diffCheck(oldData?.vendor, newData?.vendor)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Description</h6>
                        <span className="text-muted">{diffCheck(oldData?.description, newData?.description)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Redemption Code</h6>
                        <span className="text-muted">{diffCheck(oldData?.redemptionCode, newData?.redemptionCode)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Status</h6>
                        {formatStatus(oldData?.status)}
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>ID</h6>
                        <span className="text-muted">{oldData?.id}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Instrument ID</h6>
                        <span className="text-muted">{diffCheck(oldData?.instrumentId, newData?.instrumentId)}</span>
                    </div>
                    <div className="col-lg-4 py-4">
                        <h6>User ID</h6>
                        <span className="text-muted">{oldData?.userId}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Ref ID</h6>
                        <span className="text-muted">{oldData?.refid}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Account ID</h6>
                        <span className="text-muted">{oldData?.accountId}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Acount History ID</h6>
                        <span className="text-muted">{oldData?.accountHistoryId}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4 py-4">
                        <h6>Symbol</h6>
                        <span className="text-muted">{diffCheck(oldData?.asset?.symbol, newData?.asset?.symbol)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Order ID</h6>
                        <span className="text-muted">{oldData?.depositRetries}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Order Retries</h6>
                        <span className="text-muted">{oldData?.orderRetries}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Amount</h6>
                        <span className="text-muted">{diffCheck(
                            formatAmount(oldData?.currency, oldData?.amount),
                            formatAmount(newData?.currency || oldData?.currency, newData?.amount || oldData?.amount)
                        )}</span>
                    </div>
                    <div className="col-lg-4 py-4">
                        <h6>Deposit Retries</h6>
                        <span
                            className="text-muted">{oldData?.depositRetries}</span>
                    </div>
                    <div className="col-lg-4 py-4">
                        <h6>Status Comment</h6>
                        <span className="text-muted">{oldData?.statusComment}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Created At</h6>
                        <span className="text-muted">{formatDate(oldData?.createdAt)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Updated At</h6>
                        <span className="text-muted">{formatDate(oldData?.updatedAt)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg">
                        <h4 className="mb-4 mt-5 text-muted h5">More Details</h4>
                        <div className="text-muted bg-light-secondary rounded-lg p-4 overflow-auto" style={{ maxHeight: "300px" }}>
                            <pre className="mb-0">{JSON.stringify(oldData?.meta, null, 4)}</pre>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default UpdateGiftCard;